/*
 * Popup para Amix Points - Manejo de la ventana modal
 */
document.addEventListener("DOMContentLoaded", function () {
    const openButton = document.getElementById("popup-amixpoints-openButton");
    const popup = document.getElementById("popup-amixpoints");

    // Evento para abrir el popup
    if (openButton && popup) {
        openButton.addEventListener("click", function () {
            popup.style.display = "flex";
        });
    }

    // Cerrar el popup al hacer clic fuera de él
    window.onclick = function (event) {
        if (event.target == popup) {
            popupAmixpointsClose();
        }
    };

    if (window.Shopify?.customerAccount) {
      const { logged, tags = [], id, email } = Shopify.customerAccount;
      console.log('TAGS ', tags);
    }

  
});

// Función para cerrar el popup
function popupAmixpointsClose() {
    document.getElementById("popup-amixpoints").style.display = "none";
}

/*
 * Cálculo y visualización de Amix Points
 */
document.addEventListener("DOMContentLoaded", function () {
  
    // Función unificada para calcular y mostrar puntos
    function calculateAndDisplayPoints(pointsElementId, price) {
        if (!price) return;
        let totalPrice = parseFloat(price.replace(/[^\d.-]/g, ''));
        if (isNaN(totalPrice)) return;
        const points = Math.round((totalPrice / 100) * 10);
        const pointsElement = document.getElementById(pointsElementId);



        if (pointsElement) {
            if (pointsElementId === 'amix-points') {
                const template = KROWN.settings.cart.amixPoints;
                const message = template.replace('{{ points }}', points);
                pointsElement.textContent = message;
            } else {
                pointsElement.textContent = `${points}`;
            }
        }
    }

    // Función para actualizar puntos en el carrito lateral
    function updateSidebarCartPoints(price) {
        calculateAndDisplayPoints(
            'amix-points',
            price
        );
    }

    // Función para actualizar puntos en la página de carrito
    function updateCartPagePoints(price) {
        calculateAndDisplayPoints(
            'amix-points',
            price
        );
    }

    // Función para actualizar puntos en la página de producto
    function updateProductPagePoints() {
        const price = document.querySelector('.template-product product-page .product-price--original');
        if (!price) return;
        calculateAndDisplayPoints(
            'points-recibes',
            price.textContent
        );
    }

    // Configurar observadores para detectar cambios en el DOM
    const dropdownTargetNode = document.getElementById('site-cart-sidebar');
    const cartTargetNode = document.querySelector('.main-cart-page');


    // Inicializar puntos en la página de producto
    updateProductPagePoints();



    // Manejar cambios de variante en la página de producto
    const variantRadios = document.querySelectorAll('.product-variant__input');
    if (variantRadios.length > 0) {
        variantRadios.forEach(radio => {
            radio.addEventListener('change', () => {
                setTimeout(function () {
                    window.location.reload();
                }, 200);
            });
        });
    }

    // Manejar cambios de sabores en la página de producto
    const saboresRadios = document.querySelectorAll('.product-variant-container');
    if (saboresRadios.length > 0) {
        saboresRadios.forEach(option => {
            option.addEventListener('change', () => {
                setTimeout(function () {
                    window.location.reload();
                }, 200);
            });
        });
    }

      
    document.addEventListener("limoniapps:discountninja:cart:updated", function (event) {
        var { subtotal_original_price_excluding_gifts, total_original_price_excluding_gifts, total_discounted_price, CartLevelDiscounts } = event.detail.data[0];

        const loader = document.querySelector('.wrapper-loading');
        if(loader && total_discounted_price > 0) loader.classList.add('active');

        //console.log('CART UPDATED FROM DN', event.detail.data[0]);
      
        window.updateProgressBar({cartTotalArg: total_discounted_price, cartLevelDiscounts: CartLevelDiscounts});
        //window.updateProgressBarDebounced();

        const formatPrice = formatMoney(total_discounted_price, KROWN.settings.shop_money_format);
        if (dropdownTargetNode) updateSidebarCartPoints(formatPrice);
        if (cartTargetNode) updateCartPagePoints(formatPrice);

        const totalFormatted = parseFloat(total_discounted_price / 100).toFixed(2);
        const payButtonTotal = document.querySelector('.button--custom .button-custom__total');
        if (payButtonTotal) {
            payButtonTotal.textContent = `${totalFormatted}€`;
        }

        document.querySelectorAll('[data-header-cart-total]').forEach(elm => {
            elm.textContent = `${totalFormatted}€`;
        });

        const cartTotalEl = document.querySelectorAll('main-header a.desktop-cart-button');
        if (total_discounted_price > 0) {
            cartTotalEl.forEach(elm=>{
                elm.style.backgroundColor = KROWN.settings.cart.customButtonColor
            });
        } else {
            cartTotalEl.forEach(elm=>{
                elm.style.backgroundColor = KROWN.settings.cart.textColor
            });
        }

        //window.checkCartDiscount(CartLevelDiscounts);

    });

    document.addEventListener('planet:free-gift-updated', async (event) => {

        //console.log('PANET DATASET RIVO.JS:', event.detail.data);
        // const cartTotal = await getCartTotal();
        //window.updateProgressBarDebounced();
  
    });

    document.addEventListener('progress-bar:updated', (event) => {
        const cartTotal = event.detail.cart.total_price;
        console.log('PROGRESS BAR UPDATED', cartTotal / 100);

        const formatPrice = formatMoney(cartTotal, KROWN.settings.shop_money_format);
        if (dropdownTargetNode) updateSidebarCartPoints(formatPrice);
        if (cartTargetNode) updateCartPagePoints(formatPrice);

        /* const progressBar = document.querySelector('.gift-progress-bar__wrapper');
        if (progressBar && progressBar.dataset.customer) {
            const customerId = progressBar.dataset.customer;
            const loginEvent = new CustomEvent('shopify:customer:login', {
                detail: {
                    customerId: customerId,
                    timestamp: new Date().toISOString(),
                    cart: event.detail.cart
                }
            });
            
            document.dispatchEvent(loginEvent);
        } */

        if (!CustomerSession.isLogged()) return; 
      
        //if (window.__loginEventAlreadyFired) return;
      
        const customerId = CustomerSession.getId();  
        if (!customerId) return;
      
        document.dispatchEvent(new CustomEvent('shopify:customer:login', {
          detail: {
            customerId,
            tags: CustomerSession.isPatrocinio() ? ['patrocinio'] : [],
            timestamp: Date.now(),
            cart
          }
        }));
        window.__loginEventAlreadyFired = true; 
      
    });
  
    document.addEventListener('shopify:customer:login', async (event) => {
        console.log('Usuario logueado detectado, evento enviado', event.detail);
        if (event.detail.tags.includes('patrocinio')) {
          //await window.removeAllPlanetGifts(event.detail.cart);
          //window.refreshCart(); 
          console.log('tags', event.detail.tags);
        }
    });

    function formatMoney(cents, format) {

        if (typeof cents === 'string') {
            cents = cents.replace('.', '');
        }

        let value = '';
        const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        const formatString = format || moneyFormat;

        function formatWithDelimiters(number, precision, thousands, decimal) {
            thousands = thousands || ',';
            decimal = decimal || '.';

            if (isNaN(number) || number === null) {
                return 0;
            }

            number = (number / 100.0).toFixed(precision);

            const parts = number.split('.');
            const dollarsAmount = parts[0].replace(
                /(\d)(?=(\d\d\d)+(?!\d))/g,
                '$1' + thousands
            );
            const centsAmount = parts[1] ? decimal + parts[1] : '';

            return dollarsAmount + centsAmount + KROWN.settings.iso_code;
        }

        switch (formatString.match(placeholderRegex)[1]) {
            case 'amount':
                value = formatWithDelimiters(cents, 2);
                break;
            case 'amount_no_decimals':
                value = formatWithDelimiters(cents, 0);
                break;
            case 'amount_with_comma_separator':
                value = formatWithDelimiters(cents, 2, '.', ',');
                break;
            case 'amount_no_decimals_with_comma_separator':
                value = formatWithDelimiters(cents, 0, '.', ',');
                break;
            case 'amount_no_decimals_with_space_separator':
                value = formatWithDelimiters(cents, 0, ' ');
                break;
            case 'amount_with_apostrophe_separator':
                value = formatWithDelimiters(cents, 2, "'");
                break;
        }

        return formatString.replace(placeholderRegex, value);

    }

});